import { FilterCategoryEnum, FilterTypeEnum } from '@/bundles/GroupFilters/enums/FilterTypeEnum';
import { IFilterConfigItem } from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';
import { STATIC_SET_FILTER_KEY } from '@/bundles/GroupFilters/consts';

export const getStaticSetFilterConfig = (source: string): IFilterConfigItem => {
  return {
    title: 'Static Set(s)',
    name: STATIC_SET_FILTER_KEY,
    type: FilterTypeEnum.static_set_select,
    category: FilterCategoryEnum.universal,
    searchKeywords: ['saved set', 'set'],
    additional: { source },
  };
}
